import ComponentView from './ComponentView';

export default ComponentView.extend({});



// WEBPACK FOOTER //
// webpack://grapesjs/src/dom_components/view/ComponentTableFootView.js